<template>
  <div
    class="vessel-selector"
    style="max-width: 400px; width: 100%"
  >
    <v-autocomplete
      v-model="selectedVesselModel"
      :items="fleet"
      :loading="fetchFleetLoading"
      :disabled="fetchFleetLoading"
      solo
      flat
      hide-details
      dark
      background-color="rgba(255, 255, 255, 0.15)"
      color="white"
      item-color="primary"
      :placeholder="selectedVesselPlaceholder"
      item-text="vessel"
      return-object
      class="vessel-select"
      clearable
      @change="onVesselSelect"
    >
      <template v-slot:prepend-inner>
        <v-icon
          color="rgba(255, 255, 255, 0.8)"
          size="16"
        >
          mdi-ferry
        </v-icon>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">
            {{ item.vessel }}
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-center text--disabled">
              {{
                fetchFleetError ? "Error loading vessels" : "No vessels found"
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "VesselSelector",
  computed: {
    ...mapState("main", [
      "selectedVessel",
      "fleet",
      "fetchFleetLoading",
      "fetchFleetError",
    ]),

    selectedVesselPlaceholder() {
      if (this.fetchFleetLoading) return "Loading vessels...";
      if (this.fleet.length === 0) return "No vessels available";
      return "Search vessels...";
    },

    selectedVesselModel: {
      get() {
        return this.selectedVessel;
      },
      set(newVessel) {
        this.$store.commit("main/SET_SELECTED_VESSEL", newVessel);
      },
    },
  },

  methods: {
    ...mapActions("main", ["fetchFleet", "toggleDrawer"]),
    onVesselSelect(vessel) {
      const currentRoute = this.$route.name;
      if (vessel) {
        if (currentRoute === "home") {
          this._goToVesselInfo(vessel.vessel);
        } else {
          this._reloadRouteWithSelectedVessel(currentRoute, vessel.vessel);
        }
      } else {
        if (currentRoute !== "home") this._goToHome();
      }
    },
    _goToHome() {
      this.$router.push({
        name: "home",
      });
    },
    _goToVesselInfo(vesselName) {
      this.$router.push({
        name: "Vessel Info",
        params: { vessel: vesselName },
      });
    },
    _reloadRouteWithSelectedVessel(currentRoute, vesselName) {
      this.$router.push({
        name: currentRoute,
        params: { vessel: vesselName },
      });
    },
  },
};
</script>

<style scoped>
.selector-label {
  font-size: 11px;
  letter-spacing: 0.8px;
  opacity: 0.8;
}

.vessel-select::v-deep .v-input__slot {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease;
}

.vessel-select::v-deep .v-input__slot:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.vessel-select::v-deep .v-input__slot {
  padding: 12px 16px;
}

.vessel-select::v-deep .v-input--is-focused .v-input__slot {
  background-color: rgba(255, 255, 255, 0.25) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}

.vessel-select::v-deep .v-select__slot {
  color: white;
  font-weight: 500;
  font-size: 14px;
}

.vessel-select::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
}

.vessel-select::v-deep .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center;
  margin-right: 8px !important;
}

@media (max-width: 600px) {
  .selector-label {
    display: none;
  }

  .vessel-selector {
    max-width: 250px !important;
  }
}

/* Enhanced autocomplete dropdown styling */
.vessel-select::v-deep .v-menu__content {
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  margin-top: 8px !important;
}

.vessel-select::v-deep .v-list {
  background: transparent !important;
  padding: 8px 0 !important;
}

.vessel-select::v-deep .v-list-item {
  border-radius: 12px !important;
  margin: 2px 8px !important;
  padding: 12px 16px !important;
  transition: all 0.2s ease !important;
  background: transparent !important;
}

.vessel-select::v-deep .v-list-item:hover {
  background: rgba(82, 108, 223, 0.1) !important;
  transform: translateX(4px);
}

.vessel-select::v-deep .v-list-item--active {
  background: rgba(82, 108, 223, 0.15) !important;
  color: #526cdf !important;
}

.vessel-select::v-deep .v-list-item--active:hover {
  background: rgba(82, 108, 223, 0.2) !important;
}

.vessel-select::v-deep .v-list-item__title {
  font-weight: 500 !important;
  font-size: 14px !important;
  color: #2c3e50 !important;
}

.vessel-select::v-deep .v-list-item--active .v-list-item__title {
  color: #526cdf !important;
  font-weight: 600 !important;
}

.vessel-select::v-deep .v-list-item__content {
  padding: 0 !important;
}

/* Dropdown animation */
.vessel-select::v-deep .v-menu__content {
  animation: dropdownSlideIn 0.3s ease-out;
}

@keyframes dropdownSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Custom scrollbar for dropdown */
.vessel-select::v-deep .v-menu__content::-webkit-scrollbar {
  width: 6px;
}

.vessel-select::v-deep .v-menu__content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

.vessel-select::v-deep .v-menu__content::-webkit-scrollbar-thumb {
  background: rgba(82, 108, 223, 0.3);
  border-radius: 3px;
}

.vessel-select::v-deep .v-menu__content::-webkit-scrollbar-thumb:hover {
  background: rgba(82, 108, 223, 0.5);
}

.vessel-selector-icon {
  filter: brightness(0) invert(1); /* Makes the icon white */
  object-fit: contain;
}
</style>
